import React from 'react';
import cn from 'classnames';

import ActionButton from 'components/widgets/ActionButton/ActionButton';
import { ActionButtonTypesEnum } from 'interface';

import styles from './CardWithActionButton.module.scss';

type ButtonParams = {
  text: string;
  link?: string;
  blank?: boolean;
};

interface Props {
  name: string;
  className?: string;
  buttonParams: ButtonParams;
  onHandleClick?: Function;
}

export default function CardWithActionButton({ name, buttonParams, onHandleClick, className }: Props) {
  const { blank } = buttonParams;

  return (
    <div className={cn(styles.card, className)}>
      <span>{name}</span>
      <ActionButton
        onClick={onHandleClick}
        additionString={`${name} `}
        target={blank ? '_blank' : undefined}
        title={buttonParams.text}
        to={buttonParams.link}
        type={ActionButtonTypesEnum.primary}
      />
    </div>
  );
}
